
import React from 'react'

interface IProps {
  width?: string | number
  height?: string | number
  fill?: string
}


const Calendar = ({ width, height, fill = 'currentColor', ...rest }: IProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...rest}
  >
    <path fill={fill} d="M4 7v2h16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2z" />
    <path
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16 5h2a2 2 0 0 1 2 2v2H4V7a2 2 0 0 1 2-2h2m8 0V3m0 2H8m0-2v2M4 9.5V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9.5"
    />
  </svg>
);
export default Calendar;
